import VersioningUI from '@/components/VersioningUI'
import * as events from '@/events'

export default class VersioningApp {
  constructor () {
    this.root = document.querySelector('body')
  }

  get cookieVersion () {
    return document.cookie.split(';')
      .find(el => el.contains('__version'))
      .split('=')[1]
  }

  get versionFromCookie () {
    if (document.cookie.includes('__version')) return this.cookieVersion
    else return false
  }

  get versionExist () {
    return this.versionFromCookie || location.hostname === 'grecos.local'
  }

  createPlaceholder (root) {
    const div = document.createElement('div')
    div.classList.add('versioning-ui')
    root.insertAdjacentElement('beforeend', div)
  
    return div
  }

  mountVersioningComponent () {
    if (this.versionExist) new VersioningUI({
      el: this.createPlaceholder(this.root), propsData: {
        version: this.versionFromCookie || __BRANCH__,
      } })
  }

  init () {
    events.appInitialized.subscribe(() => this.mountVersioningComponent())
  }
}


// WEBPACK FOOTER //
// ./src/versioningApp.js